// extracted by mini-css-extract-plugin
export var callCard = "_nb-0";
export var callMessageButton = "_nb-1";
export var helpIcon = "_nb-3";
export var helpIconContainer = "_nb-4";
export var verticalDivider = "_nb-2";